import { render, staticRenderFns } from "./physicalDialog.vue?vue&type=template&id=a8d20ab0&scoped=true"
import script from "./physicalDialog.vue?vue&type=script&lang=js"
export * from "./physicalDialog.vue?vue&type=script&lang=js"
import style0 from "./physicalDialog.vue?vue&type=style&index=0&id=a8d20ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d20ab0",
  null
  
)

export default component.exports